/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface RunBeamConstancyMeasurementRequestDto
 */
export interface RunBeamConstancyMeasurementRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RunBeamConstancyMeasurementRequestDto
     */
    parameterCombinationHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RunBeamConstancyMeasurementRequestDto
     */
    jobOccurrenceId?: string;
    /**
     * 
     * @type {string}
     * @memberof RunBeamConstancyMeasurementRequestDto
     */
    workItemId?: string;
    /**
     * 
     * @type {string}
     * @memberof RunBeamConstancyMeasurementRequestDto
     */
    $type?: RunBeamConstancyMeasurementRequestDtoTypeEnum;
}


/**
 * @export
 */
export const RunBeamConstancyMeasurementRequestDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoRunBeamConstancyMeasurementRequestDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.RunBeamConstancyMeasurementRequestDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type RunBeamConstancyMeasurementRequestDtoTypeEnum = typeof RunBeamConstancyMeasurementRequestDtoTypeEnum[keyof typeof RunBeamConstancyMeasurementRequestDtoTypeEnum];


/**
 * Check if a given object implements the RunBeamConstancyMeasurementRequestDto interface.
 */
export function instanceOfRunBeamConstancyMeasurementRequestDto(value?: unknown): value is RunBeamConstancyMeasurementRequestDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(RunBeamConstancyMeasurementRequestDtoTypeEnum)[0];
}

export function RunBeamConstancyMeasurementRequestDtoFromJSON(json: any): RunBeamConstancyMeasurementRequestDto {
    return RunBeamConstancyMeasurementRequestDtoFromJSONTyped(json, false);
}

export function RunBeamConstancyMeasurementRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunBeamConstancyMeasurementRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parameterCombinationHash': !exists(json, 'parameterCombinationHash') ? undefined : json['parameterCombinationHash'],
        'jobOccurrenceId': !exists(json, 'jobOccurrenceId') ? undefined : json['jobOccurrenceId'],
        'workItemId': !exists(json, 'workItemId') ? undefined : json['workItemId'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function RunBeamConstancyMeasurementRequestDtoToJSON(value?: RunBeamConstancyMeasurementRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'parameterCombinationHash': value.parameterCombinationHash,
        'jobOccurrenceId': value.jobOccurrenceId,
        'workItemId': value.workItemId,
        '$type': value.$type,
    });
}

